import { http } from '../../http'
import { apiHeaders, apiBasePath } from '../../../config/api'

const servicePath = 'web/advertisements'

const validParams = ['header', 'body', 'section']
const validEvents = ['clicked', 'served', 'watched']

const filterParams = (requestParams) => {
  const params = {}
  Object.keys(requestParams).forEach((value, key) => {
    if (validParams.indexOf(value) !== -1) {
      params[value] = requestParams[value]
    }
  })
  return params
}

export const getAdvertisement = (requestParams, log) => {
  const url = `${apiBasePath}/${servicePath}`
  const data = filterParams(requestParams)
  return new Promise((resolve, reject) => {
    http(url, 'get', data, apiHeaders)
      .then((response) => {
        const request = response.data
        if (request.status === false && log === true) {
          console.error(request.message)
        }
        resolve(request.data.advertisements)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export const setAdvertisementEvent = (requestParams, log) => {
  const url = `${apiBasePath}/${servicePath}/tracking`

  if (typeof requestParams === 'undefined') {
    return false
  }

  if (('ad_id' in requestParams === false) || ('event' in requestParams === false)) {
    return false
  }

  if (validEvents.indexOf(requestParams.event) === -1) {
    return false
  }

  const data = {
    ad_id: requestParams.ad_id,
    event: requestParams.event
  }
  return new Promise((resolve, reject) => {
    http(url, 'get', data, apiHeaders)
      .then((response) => {
        const request = response.data
        if (request.status === false && log === true) {
          console.error(request.message)
        }
        resolve(request.status)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
